"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveHostAgenciesOptions = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const SortingPaginationOptions_1 = require("./SortingPaginationOptions");
let RetrieveHostAgenciesOptions = class RetrieveHostAgenciesOptions extends SortingPaginationOptions_1.SortingPaginationOptions {
};
exports.RetrieveHostAgenciesOptions = RetrieveHostAgenciesOptions;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RetrieveHostAgenciesOptions.prototype, "search", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RetrieveHostAgenciesOptions.prototype, "businessModel", void 0);
exports.RetrieveHostAgenciesOptions = RetrieveHostAgenciesOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], RetrieveHostAgenciesOptions);
//# sourceMappingURL=RetrieveHostAgenciesOptions.js.map